/** Waka linkage is an authoring identity, not a company API scene number. */
export function scriptSceneKey(item: unknown, sceneId: number | null | undefined): string {
  if (typeof sceneId === 'number' && Number.isFinite(sceneId)) return `company:${sceneId}`;
  if (item && typeof item === 'object' && 'linkGroupId' in item
    && typeof item.linkGroupId === 'string' && item.linkGroupId.trim()) {
    // Keep existing legacy key encoding stable across saved voice receipts.
    return `waka:${encodeURIComponent(JSON.stringify(item.linkGroupId))}`;
  }
  return 'unknown';
}

/** Stable scene keys may contain JSON quotes/backslashes. Match dataset values without building CSS. */
export function findScriptSceneCard(container:ParentNode,key:string):HTMLElement|undefined{return Array.from(container.querySelectorAll<HTMLElement>('[data-script-card-id]')).find(element=>element.dataset.scriptCardId===key);}
